export const isAFormMessage = message => message.content_type === 'form';
export const isASubmittedFormMessage = (message = {}) =>
  isAFormMessage(message) && !!message.content_attributes?.submitted_values;

export const MESSAGE_MAX_LENGTH = {
  GENERAL: 10000,
  EMAIL: 150000,
  FACEBOOK: 1000,
  TWILIO_SMS: 320,
  SMS: 201,
  TWILIO_WHATSAPP: 1600,
};
